import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  iconContainer: {
    width: "40px",
    height: "40px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media print": {
      display: "none",
    },
  },
  iconContainerLightMode: {
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const CloseIcon = (props) => {
  const { classes, closeFunction, darkMode = false, style } = props;

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        closeFunction();
      }}
      className={`${classes.iconContainer} ${
        !darkMode && classes.iconContainerLightMode
      }`}
      style={style}
    >
      <img
        src={darkMode ? images.closeIconWhite : images.closeIcon}
        alt="close"
      />
    </Box>
  );
};

CloseIcon.propTypes = {
  closeFunction: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};

export default withStyles(styles)(CloseIcon);
